module.exports = __webpack_public_path__ + "static/media/galerija_2016 (13).497f42df.jpg";